<template>
	<div class="flex_1 margin_horizontal">
		<AccessRestrictedTabs class="table_tabs"
							  v-model="activeTab"
							  :elements="tabTypes"
							  :session-key="$route.path"
		/>
		<SellTable v-if="activeTab === tabTypes.approvedReceivables" @changed="updateCounts"/>
		<SellCurrentTable v-if="activeTab === tabTypes.sellingReceivables" @changed="updateCounts"/>
		<PaymentTable v-if="activeTab === tabTypes.payments"/>
		<ReceivableTableWithFilter v-if="activeTab === tabTypes.receivables"></ReceivableTableWithFilter>

		<!-- Disabled until feature redesign -->
		<!-- <InvestorTable v-if="activeTab === tabTypes.investorList"></InvestorTable> -->
	</div>
</template>

<script>
import SellTable from "@/components/templates/seller/sell/SellTable.vue";
import SellCurrentTable from "@/components/templates/seller/sell/SellCurrentTable.vue";
import {sellApi} from "@/common/api/sellApi";
import {enumDef} from "@/common/enumDefs";
import AccessRestrictedTabs from "@/components/templates/common/permissions/AccessRestrictedTabs";
import PaymentTable from "@/components/templates/seller/payments/PaymentTable";
import ReceivableTableWithFilter from "@/components/templates/seller/receivables/ReceivableTableWithFilter";
import InvestorTable from "@/components/templates/investorManagement/InvestorTable";
import {navigationTabs} from "@/common/navigation/navigationTabs";
import {hasAccess} from "@/common/permission/permission";

export default {
	components: { SellTable, SellCurrentTable, PaymentTable, ReceivableTableWithFilter, InvestorTable, AccessRestrictedTabs },
	data() {
		let tabTypes = {
			approvedReceivables: {
				name: navigationTabs.seller.sell.approved,
				translationKey: "seller.sell.ApprovedExchange",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null
			},
			sellingReceivables: {
				name: navigationTabs.seller.sell.selling,
				translationKey: "seller.sell.Transaction",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null
			},
			payments: {
				name: navigationTabs.seller.sell.payments,
				translationKey: "seller.sell.payments",
				permission: enumDef.permissions.SellerSellReceivables,
				count: null
			},
			receivables: {
				name: navigationTabs.seller.sell.receivables,
				translationKey: "seller.sell.allReceivables",
				permission: enumDef.permissions.SellerSellReceivables
			}
			// Disabled until feature redesign
			/*investorList: {
				name: navigationTabs.seller.sell.investors,
				translationKey: "seller.sell.investors",
				permission: enumDef.permissions.SellerInvestorManagement
			}*/
		};

		return {
			tabTypes: tabTypes,
			activeTab: null
		};
	},
	created() {
		this.updateCounts();
	},
	methods: {
		updateCounts() {
			if (hasAccess(this.currentUser, enumDef.permissions.SellerSellReceivables)) {
				sellApi.inspection.counts()
					.then(counts => {
						this.tabTypes.approvedReceivables.count = counts.approvedCount;
						this.tabTypes.sellingReceivables.count = counts.sellingCount;
					});
			}
		},
	},
};
</script>
